function psScrollTop(el: any): void {
  el.$el.classList.add('scroll-auto');
  el.$el.scrollTop = 0;
  el.$el.classList.remove('scroll-auto');
}

function psScrollTo(el, position) {
  el.$el.classList.add('scroll-auto');
  el.$el.scrollTop = position;
  // el.$el.scrollIntoView();
  el.$el.classList.remove('scroll-auto');
}

function psScrollToLeft(el, position) {
  el.$el.classList.add('scroll-auto');
  el.$el.scrollLeft = position;
  // el.$el.scrollIntoView();
  el.$el.classList.remove('scroll-auto');
}

export { psScrollTo, psScrollTop, psScrollToLeft };
